import { ICellRendererParams, ValueFormatterParams } from "ag-grid-community";
import { PaymentSchedule } from "../../../../../../types/bookings";
import { GridType } from "../../../../../../types/grid";
import { convertToSentenceCase, formatCurrency, formatDateByType, formatNumber } from "../../../../../libs/utils";

export const previewScheduleColumns: GridType[] = [
  {
    id: "installments",
    field: "installments",
    headerName: "Inst #",
    flex: 0.7,
  },
  {
    id: "description",
    field: "description",
    headerName: "Payment Type",
    flex: 1.2,
    valueFormatter: ({ value }: ValueFormatterParams<PaymentSchedule, PaymentSchedule["description"]>) => {
      return convertToSentenceCase(value);
    },
  },
  {
    id: "actualAmount",
    field: "actualAmount",
    headerName: "Amount",
    flex: 1.3,
    type: "rightAligned",
    valueFormatter: ({ value, data }: ValueFormatterParams<PaymentSchedule, PaymentSchedule["actualAmount"]>) => {
      const amount = data?.isWriteOff ? -Math.abs(value) : value;
      return formatCurrency(amount);
    },
  },
  {
    id: "vat",
    field: "vat",
    headerName: "VAT",
    flex: 1.3,
    type: "rightAligned",
    valueFormatter: ({ value }: ValueFormatterParams<PaymentSchedule, PaymentSchedule["vat"]>) => {
      return formatCurrency(value);
    },
  },
  {
    id: "vatInPercentage",
    field: "vatInPercentage",
    headerName: "VAT %",
    flex: 0.7,
    type: "rightAligned",
    cellRenderer: ({ value }: ICellRendererParams<PaymentSchedule, PaymentSchedule["vat"]>) => {
      return formatNumber(value);
    },
  },
  {
    id: "totalAmount",
    field: "totalAmount",
    headerName: "Total Amount",
    flex: 1.3,
    type: "rightAligned",
    valueFormatter: ({ value, data }: ValueFormatterParams<PaymentSchedule, PaymentSchedule["totalAmount"]>) => {
      const amount = data?.isWriteOff ? -Math.abs(value) : value;
      return formatCurrency(amount);
    },
  },
  {
    id: "dueDate",
    field: "dueDate",
    headerName: "Due Date",
    flex: 1,
    valueFormatter: ({ value }: ValueFormatterParams<PaymentSchedule, PaymentSchedule["dueDate"]>) => {
      return formatDateByType(value);
    },
  },
  {
    id: "invoiceDate",
    field: "invoiceDate",
    headerName: "Invoice Date",
    flex: 1,
    valueFormatter: ({ value }: ValueFormatterParams<PaymentSchedule, PaymentSchedule["invoiceDate"]>) => {
      return formatDateByType(value);
    },
  },
];
